import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const ProtectedRoute = ({ children }) => {
  const { token, loading } = useAuth();
  if (loading) return <div>Loading...</div>; // kurz warten, bis localStorage ausgelesen
  return token ? children : <Navigate to="/login" />;
};

export default ProtectedRoute;